export default {
    advancing_burn: {
        name: "Advancing Burn",
        url: "bcws/advancing_burn",
    },
    aerial_hazard: {
        name: "Aerial Hazard",
        url: "bcws/aerial_hazard",
    },
    backing_burn: {
        name: "Backing Burn",
        url: "bcws/backing_burn",
    },
    bowser: {
        name: "Bowser",
        url: "bcws/bowser",
    },
    camp_name: {
        name: "Camp Name",
        url: "bcws/camp_name",
    },
    casings: {
        name: "Casings",
        url: "bcws/casings",
    },
    casings_arc_100: {
        name: "Casings Arc 100",
        url: "bcws/casings_arc_100",
    },
    cattle_guard: {
        name: "Cattle Guard",
        url: "bcws/cattle_guard",
    },
    cleared_area: {
        name: "Cleared Area",
        url: "bcws/cleared_area",
    },
    cross_x_ditch: {
        name: "Cross X Ditch",
        url: "bcws/cross_x_ditch",
    },
    cross_x_ditch_filled: {
        name: "Cross X Ditch Filled",
        url: "bcws/cross_x_ditch_filled",
    },
    danger_tree_assessed: {
        name: "Danger Tree Assessed",
        url: "bcws/danger_tree_assessed",
    },
    danger_tree_assessed_1: {
        name: "Danger Tree Assessed 1",
        url: "bcws/danger_tree_assessed_1",
    },
    decked_wood: {
        name: "Decked Wood",
        url: "bcws/decked_wood",
    },
    drop_point_label: {
        name: "Drop Point Label",
        url: "bcws/drop_point_label",
    },
    evidence_point: {
        name: "Evidence Point",
        url: "bcws/evidence_point",
    },
    fence: {
        name: "Fence",
        url: "bcws/fence",
    },
    fence_undamaged: {
        name: "Fence Undamaged",
        url: "bcws/fence_undamaged",
    },
    fire_origin_date_and_time: {
        name: "Fire Origin Date And Time",
        url: "bcws/fire_origin_date_and_time",
    },
    first_aid_station: {
        name: "First Aid Station",
        url: "bcws/first_aid_station",
    },
    grid_search_corner_post: {
        name: "Grid Search Corner Post",
        url: "bcws/grid_search_corner_post",
    },
    hazard: {
        name: "Hazard",
        url: "bcws/hazard",
    },
    helibase: {
        name: "Helibase",
        url: "bcws/helibase",
    },
    helispot_label: {
        name: "Helispot Label",
        url: "bcws/helispot_label",
    },
    high_berm: {
        name: "High Berm",
        url: "bcws/high_berm",
    },
    hotspot_label: {
        name: "Hotspot Label",
        url: "bcws/hotspot_label",
    },
    incident_base: {
        name: "Incident Base",
        url: "bcws/incident_base",
    },
    incident_command_post: {
        name: "Incident Command Post",
        url: "bcws/incident_command_post",
    },
    item_of_interest: {
        name: "Item Of Interest",
        url: "bcws/item_of_interest",
    },
    lateral_burn: {
        name: "Lateral Burn",
        url: "bcws/lateral_burn",
    },
    lookout: {
        name: "Lookout",
        url: "bcws/lookout",
    },
    medivac_spot: {
        name: "Medivac Spot",
        url: "bcws/medivac_spot",
    },
    mine: {
        name: "Mine",
        url: "bcws/mine",
    },
    mixing_station: {
        name: "Mixing Station",
        url: "bcws/mixing_station",
    },
    mobile_weather_station_deactivated: {
        name: "Mobile Weather Station Deactivated",
        url: "bcws/mobile_weather_station_deactivated",
    },
    no_treatment_point: {
        name: "No Treatment Point",
        url: "bcws/no_treatment_point",
    },
    no_work_zone: {
        name: "No Work Zone",
        url: "bcws/no_work_zone",
    },
    other_disturbance: {
        name: "Other Disturbance",
        url: "bcws/other_disturbance",
    },
    other_investigation: {
        name: "Other Investigation",
        url: "bcws/other_investigation",
    },
    other_unassigned: {
        name: "Other Unassigned",
        url: "bcws/other_unassigned",
    },
    photo_point: {
        name: "Photo Point",
        url: "bcws/photo_point",
    },
    point_of_comencement: {
        name: "Point Of Comencement",
        url: "bcws/point_of_comencement",
    },
    point_of_termination: {
        name: "Point Of Termination",
        url: "bcws/point_of_termination",
    },
    public_building: {
        name: "Public Building",
        url: "bcws/public_building",
    },
    pull_back: {
        name: "Pull Back",
        url: "bcws/pull_back",
    },
    pump: {
        name: "Pump",
        url: "bcws/pump",
    },
    rain_gauge: {
        name: "Rain Gauge",
        url: "bcws/rain_gauge",
    },
    rec_site: {
        name: "Rec Site",
        url: "bcws/rec_site",
    },
    rehab_point_other: {
        name: "Rehab Point Other",
        url: "bcws/rehab_point_other",
    },
    repeater_mobile_relay: {
        name: "Repeater Mobile Relay",
        url: "bcws/repeater_mobile_relay",
    },
    road_closure: {
        name: "Road Closure",
        url: "bcws/road_closure",
    },
    road_closure_area: {
        name: "Road Closure Area",
        url: "bcws/road_closure_area",
    },
    safety_zone: {
        name: "Safety Zone",
        url: "bcws/safety_zone",
    },
    sign: {
        name: "Sign",
        url: "bcws/sign",
    },
    spot_fire_date_and_time: {
        name: "Spot Fire Date And Time",
        url: "bcws/spot_fire_date_and_time",
    },
    staging_area_name: {
        name: "Staging Area Name",
        url: "bcws/staging_area_name",
    },
    straw_bale: {
        name: "Straw Bale",
        url: "bcws/straw_bale",
    },
    stream_crossing: {
        name: "Stream Crossing",
        url: "bcws/stream_crossing",
    },
    structure: {
        name: "Structure",
        url: "bcws/structure",
    },
    structure_unconfirmed_1: {
        name: "Structure Unconfirmed 1",
        url: "bcws/structure_unconfirmed_1",
    },
    structure_unconfirmed_2: {
        name: "Structure Unconfirmed 2",
        url: "bcws/structure_unconfirmed_2",
    },
    structure_unconfirmed_3: {
        name: "Structure Unconfirmed 3",
        url: "bcws/structure_unconfirmed_3",
    },
    structure_unconfirmed_4: {
        name: "Structure Unconfirmed 4",
        url: "bcws/structure_unconfirmed_4",
    },
    structure_unconfirmed_5: {
        name: "Structure Unconfirmed 5",
        url: "bcws/structure_unconfirmed_5",
    },
    sump: {
        name: "Sump",
        url: "bcws/sump",
    },
    telephone: {
        name: "Telephone",
        url: "bcws/telephone",
    },
    tower: {
        name: "Tower",
        url: "bcws/tower",
    },
    tree_or_lightning_stike: {
        name: "Tree Or Lightning Stike",
        url: "bcws/tree_or_lightning_stike",
    },
    unknown: {
        name: "Unknown",
        url: "bcws/unknown",
    },
    value: {
        name: "Value",
        url: "bcws/value",
    },
    water_bar: {
        name: "Water Bar",
        url: "bcws/water_bar",
    },
    water_source_identify_type: {
        name: "Water Source Identify Type",
        url: "bcws/water_source_identify_type",
    },
    weather_station: {
        name: "Weather Station",
        url: "bcws/weather_station",
    },
    weather_station_deactivated: {
        name: "Weather Station Deactivated",
        url: "bcws/weather_station_deactivated",
    },
    wind_speed_direction: {
        name: "Wind Speed Direction",
        url: "bcws/wind_speed_direction",
    },
}
